import request from "@/utils/request";

// 角色管理-列表
export function roleListApi(data) {
    return request({
      url: "/admin/admin_roles",
      method: "get",
      params: data
    });
  }

// 角色管理-新增 
export function addRoleApi(data) {
    return request({
      url: "/admin/admin_roles",
      method: "post",
      data
    });
  }

// 角色管理-编辑 (提交)
export function editRoleApi(data) {
    return request({
      url: "/admin/set_role_permissions/" + data.id ,
      method: "put",
      data
    });
  }

// 角色管理-删除
export function deleteRoleApi(data) {
    return request({
      url: "/admin/admin_roles/" + data.id ,
      method: "delete",
      data
    });
  }

// 禁用/还原角色状态
export function setRoleStatusApi(data) {
    return request({
      url: "/admin/set_role_status/" + data.id ,
      method: "put",
      data
    });
  }

// 获取权限树
export function getPermissionTreeApi(data) {
    return request({
      url: "/admin/get_permission_tree",
      method: "get",
      params: data
    });
  }

// 获取角色已选权限
export function getRolePermissionApi(data) {
    return request({
      url: "/admin/get_role_permissions",
      method: "get",
      params: data
    });
  }

// 给角色分配权限
export function setRolePermissionApi(data) {
    return request({
      url: "/admin/set_role_permissions/" + data.id,
      method: "put",
      data
    });
  }
